export default "__VITE_ASSET__CcQKT9mb__"